module.exports = __webpack_public_path__ + "static/media/zigloi.188e4850.jpg";